import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_pagedialog');

register('wm-pagedialog', (): IBuildTaskDef => {
  return {
    pre: (attrs, shared) => {
      const counter = idGen.nextUid();
      return `<${tagName} wmPageDialog partialContainer #${counter}="wmPageDialog" ${getAttrMarkup(attrs)}>`
    },
    post: (attrs, shared) => {
      return `</${tagName}>`
    }
  };
});

export default () => { };

